import React from "react";
import "../assets/css/AboutWelcomeSection.css";
import arrowImg from "../assets/images/About.jpg";


const AboutWelcomeSection = () => {
  return (
    <section className="welcome-section mt-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2>
            Welcome To <span className="highlight mb-5">Biopharmacieaa</span>
          </h2>
          
        </div>

        <div className="row align-items-center" >
          {/* LEFT TEXT CONTENT */}
          <div className="col-lg-6 col-md-12 slide-in-left">
            <div className="welcome-text">
              <p>
                We at <strong>Biopharmacieaa</strong> aim to enhance the
                understanding, management, and treatment of myriads of skin and
                hair concerns to deliver an authentic solution for your needs.
                We encourage effective patient management using evidence-based
                therapy within the discipline of dermatology. We are clinically
                oriented in catering to several services in skin and hair health
                management.
              </p>

              <p>
                <strong>Biopharmacieaa</strong> is at the forefront of skincare.
                We integrate innovative delivery technology with scientifically
                verified ingredients. We believe in providing actual, obvious
                effects in the areas of hair loss, premature aging/photoaging,
                acne therapy, photo-protection, emollients, psoriatic therapy &
                various other dermatological indications.
              </p>

              <p>
                <strong>Biopharmacieaa</strong> collaborates with major
                universities, medical institutions, and experts globally to
                produce effective products using the most recent advances and
                cutting-edge thinking. We provide strategic solutions to guide
                you through your skincare journey.
              </p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="col-lg-6 col-md-12 text-center slide-in-right">
            {/* <div className="image-container">
                <img src={arrowImg} alt="LEAD" className="img-fluid" />
                
                <div className="float-1"></div>
                <div className="float-2"></div>
                <div className="float-3"></div>
                <div className="float-4"></div>
            </div> */}
            <div class="image-container slide-in-right">
                <img src={arrowImg}alt="Welcome" />
                <div class="floating-hex"></div>
                </div>

            </div>
        </div>
      </div>
    </section>
  );
};

export default AboutWelcomeSection;
